import * as firebase from 'firebase/app'
import { createBrowserHistory } from 'history'
import Raven from 'raven-js'
import React from 'react'
import ReactDOM from 'react-dom'
// import ReactGA from 'react-ga'
import { Provider } from 'react-redux'
import { ReactReduxFirebaseProvider, ReactReduxFirebaseProviderProps } from 'react-redux-firebase'
import { Redirect, Route, Switch } from 'react-router'
import { ConnectedRouter } from 'react-router-redux'
import { createFirestoreInstance } from 'redux-firestore'

import unregisterServiceWorker from 'src/unregisterServiceWorker'
import App from './App'
import FlightResultsApp from './components/mobile/FlightResultsApp'
import { firebaseConfig } from './config'
import configureStore from './redux/configureStore'

// tslint:disable-next-line
require('firebase/functions')

const history = createBrowserHistory() // time to write history :D
const store = configureStore(firebaseConfig, history)

/*
// temporarily disabled
if (firebaseConfig.ga) {
  ReactGA.initialize(firebaseConfig.ga)

  history.listen((location, action) => {
    ReactGA.set({ page: location.pathname })
    ReactGA.pageview(location.pathname)
  })
}
*/

if (firebaseConfig.RAVEN_DSN) {
  Raven.config(firebaseConfig.RAVEN_DSN, {
    release: process.env.REACT_APP_BUILD_SHA || 'unreleased',
    environment: 'production',
    dataCallback: (data) => ({
      ...data,
      extra: {
        ...data.extra,
        storeState: store.getState(),
      },
    }),
  }).install()
}

firebase.initializeApp(firebaseConfig)

// react-redux-firebase config
export const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: true,
  updateProfileOnLogin: false,
}

export const rrfProps: ReactReduxFirebaseProviderProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance: createFirestoreInstance as FIXME,
}

ReactDOM.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...rrfProps}>
      <ConnectedRouter history={history}>
        <Switch>
          {/* tslint:disable jsx-no-lambda */}
          <Route
            path="/:tenant/tournaments/:tournament/flights/:flight/results"
            render={(routeParams) => (
              <FlightResultsApp
                tenant={routeParams.match.params.tenant}
                tournamentId={routeParams.match.params.tournament}
                flightId={routeParams.match.params.flight}
                secret={routeParams.location.hash && routeParams.location.hash.substr(1)}
              />
            )}
          />
          {/* tslint:enable jsx-no-lambda */}
          <Route path="/:tenant" component={App} />
          <Redirect from="/" to="/ag" /> {/* We have only one tenant ATM */}
        </Switch>
      </ConnectedRouter>
    </ReactReduxFirebaseProvider>
  </Provider>,
  document.getElementById('root'),
)

// vire: after removing service worker on devices previously using svc worker
// we need to purge otherwise it will still try to use cached versions
unregisterServiceWorker()



// WEBPACK FOOTER //
// ./src/index.tsx